import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";

const SpeechProgress = ({
    message,
    progress,
}) => {
    const isOnMobileScreen = useMediaQuery("(max-width: 767px)");

    const getProgressBarColor = () => {
        if (progress < 50) return "#896BFF"; // Light red
        if (progress < 80) return "#896BFF"; // Light yellow
        return "#896BFF"; // Purple (final progress)
    };

    return (
        <>
            <div
                className="d-flex"
                style={{
                    textAlign: "center",
                    flexDirection: "column",
                }}
            >
                <div
                    style={{
                        width: "100%",
                        height: isOnMobileScreen ? "48px" : "24px",
                        background: "#F6F5F8",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    <div
                        style={{
                            height: "100%",
                            width: `${progress}%`,
                            backgroundColor: getProgressBarColor(),
                            transition: "width 0.3s ease-in-out",
                        }}
                    ></div>
                    <span
                        className="body-2"
                        style={{
                            width: "100%",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            whiteSpace: isOnMobileScreen ? "wrap" : "nowrap",
                            color: "#000",
                            fontSize: "12px",
                        }}
                    >
                        {message
                            ? message
                            : "We expect you to speak for 1 minute or almost 250 words."}
                    </span>
                </div>
            </div>
        </>
    );
};

export default SpeechProgress;
